module.exports = __webpack_public_path__ + "img/zoomout.75fa0774.svg";